<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="400">
			<v-card>
				<v-form ref="formChangePassword" role="form" v-on:submit.prevent="simpan">
					<v-card-title class="text-h6" >Ubah Kata Sandi Pengguna</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-row>
									<v-col cols="12" sm="12" md="12" class="pb-0">
										<v-text-field outlined dense @focus="() => konfirmResponse.password=''" :error-messages="konfirmResponse.password" :rules="[inputrules.required, inputrules.password]" v-model="password" :type="typeInput" :append-icon="icon" @click:append="showPassword" label="Kata Sandi Baru" hint="Password minimal 6 karakter"></v-text-field>
									</v-col>
									<v-col cols="12" sm="12" md="12" class="pb-0">
										<v-text-field outlined dense @focus="() => alertRepassword=''" :error-messages="alertRepassword" v-model="repassword" :type="typeInput2" :rules="[inputrules.required]" :append-icon="icon2" @click:append="showRepassword" label="Ulangi Kata Sandi"></v-text-field>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="grey darken-1" outlined @click="hide">Batal</v-btn>
						<v-btn color="primary" depressed type="submit">Simpan</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			password: '',
			repassword: '',
			alertRepassword: '',
			typeInput: 'password',
			icon: 'mdi-eye',
			typeInput2: 'password',
			icon2: 'mdi-eye',
		}
	},
	props: {
		selectedUser: String,
		filter: Object,
		type: String,
	},
	computed: {
		...mapState('userList', ['konfirmResponse', 'responSukses']),
	},
	methods: {
		...mapActions('userList', ['getUser', 'getUserAll', 'addCategory', 'updatePasswordAll']),
		...mapActions('supplierUser', ['getDataUser', 'updatePasswordSupplier']),
		...mapMutations('userList', ['konfirmasiSukses']),
		...mapMutations(['setOverlay']),

		show(){
			this.dialog = true
		},
		hide() {
			this.konfirmasiSukses('')
			this.$refs.formChangePassword.reset()
			this.dialog = false
		},
		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		showRepassword() {
			this.typeInput2 = this.typeInput2 == 'text' ? 'password' : 'text'
			this.icon2 = this.icon2 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		async simpan() {
			await this.setOverlay(true)
			if (this.password !== this.repassword) {
				this.alertRepassword = await "Password tidak sama"
			} else {
				this.alertRepassword = await ''
				if (this.$refs.formChangePassword.validate()) {
					let param = await {
						id: this.selectedUser,
						password: this.password
					}
					if (this.type == 'supplier') {
						await this.updatePasswordSupplier(param).then( () => {
							this.$emit('getData')
							this.hide()
						})
					} else {
						await this.updatePasswordAll(param).then( () => {
							if(this.responSukses.code == 200) {
								if (this.type == 'warehouse') {
									this.getUser(this.queryString(this.filter))
								} else if (this.type == 'warehouseAll'){
									this.getUserAll(this.queryString(this.filter))
								}
								this.hide()
							}
						})
					}
				}
			}
			await this.setOverlay(false)
		},
	}
}
</script>
